<template>
	<div class="banner1">
		<div id="" class="banner_logo">
			<div :class="'logo_title ' + logoAnishow ">
				<img :class="'banner1_logo banner1_logo_left ' + aniShowleft" src="../../assets/logo/lw.png" >
				<img :class="'banner1_logo banner1_logo_right ' + aniShowright" src="../../assets/logo/rw.png" >
				Gamehaus
				<span class="logo_title_icon"></span>
			</div>
			<div id="" class="logo_desc_sub">
				<p class="">
					We shepherd your way. 
				</p>
				<p class="">
					<!-- {{$t('banner1.logosubtitle')}} -->
					We help you make the best game you can.
				</p>
			</div>
		</div>
		<div id="" class="banner1_text en_banner1_text">
			{{ani}}
			<span style="margin-left: 1rem;" :class="stop ? 'hide': ''">ǀ</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['curpage', 'aniDownUp'],
		data () {
			return {
				aniText: 'A Union Of Game Makers',
				ani: '',
				anitimes: 0,
				showText: false,
				aniShowleft: '', // 一开始为空 banner1_logo_left_Ani
				aniShowright: '', // 一开始为空 banner1_logo_right_Ani
				logoAnishow: '', // down 或者up
				stop: false
			}
		},
		watch: {
			curpage: {
				handler (newValue) {
					// console.log(newValue, 'curpage')
					if (newValue === 1 && !this.stop) { // 进入当前页面
						this.mergeText(0)
						this.logoAnishow = ''
						this.aniShowleft = ''
						this.aniShowright = ''
					} else {
						setTimeout(()=> {
							this.ani = this.aniText
						}, 300)
					}
				},
				immediate: true
			},
			aniDownUp: { // 目前滑动的状态 up 向上 ， down向下
				handler (newvalue) {
					// console.log(newvalue, 'newvalue')
					this.anitimes = 0 // 此时变成0，上下滚动了之后
					this.logoAnishow = newvalue
				}
			}
		},
		mounted () {
			// this.mergeText(0)
			// console.log(0)
			// console.log(this.curpage)
		},
		methods: {
			mergeText(index) {
				this.showText = true
				this.anitimes = 1
				if (this.curpage !== 1) {
					return
				}
				if (index == this.aniText.length) {
					this.showText = false
					this.stop = true
					setTimeout(() => {
						this.aniShowleft = 'banner1_logo_left_Ani'
						this.aniShowright = 'banner1_logo_right_Ani'
					}, 1000)
					return
				}
				if (index == 0) {
					this.ani = ''
					this.anitimes += 1
				}
				this.ani += this.aniText[index]
				let i = index + 1
				setTimeout(() => {
					this.showText = false
					this.mergeText(i)
					
				}, 100)
			},
			subText(index) {
				this.showText = true
				if (this.curpage !== 1) {
					return
				}
				if (this.anitimes == 1) { // 第一次做完填充文字的动画
					setTimeout(() => {
						this.aniShowleft = 'banner1_logo_left_Ani'
						this.aniShowright = 'banner1_logo_right_Ani'
					}, 500)
				}
				if (index == 0) {
					this.mergeText(0)
					return 
				}
				this.ani = this.aniText.substr(0, index)
				let i = index - 1
				setTimeout(() => {
					this.showText = false
					this.subText(i)
				}, 100)
			}
		}
	}
</script>

<style lang="scss">
	@keyframes logoAmi {
		from {
			left: -3rem;
		}
		to {
			left: 0;
			width: 2.5rem;
		}
	}
	@-webkit-keyframes logoAmi /* Safari and Chrome */
	{
		from {
			left: -3rem;
		}
		to {
			left: 0;
			width: 2.5rem;
		}
	}
	.hide {
		opacity: 0;
	}
	.banner1 {
		height: 100vh;
		background-image: url('../../assets/bg.jpg');
		// background-image: url(../../assets/1.png);
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		position: relative;
		.logo_title {
			font-size: 1rem;
			// font-weight: 700;
			color: #fff;
			padding: 0;
			width: 31.9375rem;
			position: relative;
			box-sizing: border-box;
			position: absolute;
			top: 40%;
			height: 2.25rem;
			transform: translateY(-50%);
			.banner1_logo {
				width: 2.5rem;
				position: absolute;
				transform: translateY(-50%);
				display: block;
				top: -50%;
			}
			.banner1_logo_left {
				width: 2.4rem;
				left: 0;
			}
			.banner1_logo_left_Ani {
				animation: logoAmi 1s;
				animation-fill-mode:forwards;
				animation-timing-function:ease-in;
			}
			.banner1_logo_right {
				left: 2.5rem;
				width: 2.4rem;
			}
			.banner1_logo_right_Ani {
				animation: logoRAmi 1s;
				animation-fill-mode:forwards;
				-webkit-animation-fill-mode:forwards; /* Safari 和 Chrome */
				animation-timing-function:ease-in;
			}
			.logo_title_icon {
				font-size: 0.375rem;
				vertical-align: super;
				margin-left: -10px;
			}
		}
		.down {
			animation: logoAmi_down 0.5s;
			animation-fill-mode:forwards;
			animation-timing-function:ease-in;
		}
		.logo_desc_sub {
			position: absolute;
			font-size: 1rem;
			top: 50%;
			transform: translateY(-50%);
			color: #fff;
			position: absolute;
		}
		.cnlogo_desc_sub {
			font-size: 1.7rem;
			// font-weight: 700;
			color: #fff;
			font-family: 'PingFangSC-Semibold';
			position: absolute;
		}
		.banner1_text {
			-webkit-text-stroke: 1px #fff;  
			-webkit-text-fill-color : transparent;
			// margin-top: 0.8rem;
			position: absolute;
			top: 70%;
			transform: translateY(-50%);
		}
		.cn_banner1_text {
			font-family: 'PingFangSC-Semibold';
			font-size: 1.65rem; 
			margin-top: 1.5rem;
			font-size: 1.775rem;
			 position: absolute;
		}
		.en_banner1_text {
			font-size: 2.075rem; 
			margin-top: 1.5rem;
			font-family: 'PilatTest-Bold';
			position: absolute;
		}
	}
	@keyframes logoAmi {
		0% {
			left: 0rem;
			// top: 70%;
		}
		100% {
			// left: 0;
			width: 0.5rem;
			top: -0.25rem;
		}
	}
	@keyframes logoAmi_down {
		0% {
			color: red;
			transform: translateY(50%);
		}
		80% {
			opacity: 0.8;
			transform: translateY(400%);
		}
		100% {
			// opacity: 0;
			transform: translateY(430%);
			opacity: 0;
		}
	}
	@keyframes logoRAmi {
		0% {
			width: 2.4rem;
			// top: 70%;
		}
		100% {
			// left: 0;
			width: 0.5rem;
			top: -0.25rem;
			left: 4.45rem;
		}
	}
</style>
